import { DownloadButtons } from '../components/DownloadButtons';
import { SEO } from '../components/SEO';
import { generateWebPageSchema, getBaseUrl } from '../utils/seo';
import './ResearchToolsPage.css';

/**
 * Performance Max Landing Page - Research Tools
 * Optimized for Google Performance Max ad traffic
 */
export function ResearchToolsPage() {
  const baseUrl = getBaseUrl();
  const structuredData = generateWebPageSchema({
    url: `${baseUrl}/research-tools`,
    title: 'Research Market Comparison Platform - Peptide Finder',
    description: 'Track pricing trends, vendor availability, and alerts across the research supply market. Independent platform with vendor comparison tools, price alerts, and educational resources.',
  });

  return (
    <>
      <SEO
        title="Research Market Comparison Platform - Peptide Finder"
        description="Track pricing trends, vendor availability, and alerts across the research supply market. Vendor comparison tools, price movement alerts, and educational research resources."
        keywords="research peptides, peptide comparison, vendor comparison, price alerts, research tools, peptide market analysis"
        structuredData={structuredData}
      />
      <div className="research-tools-page">
        <header className="research-tools-header">
          <div className="research-tools-container">
            <h1 className="research-tools-title">
              Research Market Comparison Platform
            </h1>
            <p className="research-tools-subtitle">
              Track pricing trends, vendor availability, and alerts across the research supply market.
            </p>
            <DownloadButtons
              appStoreUrl="https://apps.apple.com/us/app/peptide-library-peptide-log/id6755092737"
              googlePlayUrl="https://play.google.com/store/apps/details?id=com.peptidefinder.app"
              className="research-tools-download-buttons"
            />
          </div>
        </header>

        <main className="research-tools-main">
          <div className="research-tools-container">
            <section className="research-tools-features" aria-label="Platform features">
              <h2 className="research-tools-features-title">Platform Features</h2>
              <ul className="research-tools-features-list">
                <li className="research-tools-feature-item">
                  <span className="research-tools-feature-bullet">•</span>
                  <span className="research-tools-feature-text">Vendor comparison tools</span>
                </li>
                <li className="research-tools-feature-item">
                  <span className="research-tools-feature-bullet">•</span>
                  <span className="research-tools-feature-text">Price movement alerts</span>
                </li>
                <li className="research-tools-feature-item">
                  <span className="research-tools-feature-bullet">•</span>
                  <span className="research-tools-feature-text">Educational research resources</span>
                </li>
                <li className="research-tools-feature-item">
                  <span className="research-tools-feature-bullet">•</span>
                  <span className="research-tools-feature-text">Independent platform — no sales</span>
                </li>
              </ul>
            </section>

            <section className="research-tools-disclaimer" aria-label="Disclaimer">
              <div className="research-tools-disclaimer-content">
                <p className="research-tools-disclaimer-text">
                  For educational and research purposes only. We do not sell or promote substances.
                </p>
                <p className="research-tools-disclaimer-text">
                  PeptideFinder provides market data and comparison tools only and does not advise on usage, administration, or application of any substances.
                </p>
              </div>
            </section>
          </div>
        </main>
      </div>
    </>
  );
}
